import { Link } from 'react-router'
import { openPreferences } from '#app/utils/consent/consent.client'
import { cn } from '#app/utils/misc'
import { siteContent } from '#app/utils/site/content'
import { SITE_LINKS } from '#app/utils/site/site-links'
import { Wordmark } from './Wordmark'

const LEGAL_LINK = cn(
	'rounded-sm transition-colors duration-200 hover:text-white',
	'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-offset-2 focus-visible:ring-offset-tt-ink-2',
)

/**
 * The dark footer from the reference: 18px white wordmark, Terms, Privacy and
 * the Your Privacy Choices button (opens the cookie preferences dialog; the
 * reference of 2026-10-02 replaced the Cookie Policy link with it)
 * right-aligned at 13px (white on hover), and the copyright at 12.5px on
 * its own line. The reference draws the copyright at 40% white (3.6:1 on
 * the footer); ours is 60% (6.3:1) to reach the 4.5:1 text minimum. The gutters follow the page column (40px, 18px on
 * phones) so the footer lines up with the content above it.
 */
export function SiteFooter() {
	const copy = siteContent.footer
	return (
		<footer className="border-t border-white/10 bg-tt-ink-2 leading-tight text-white/60">
			<div className="mx-auto flex max-w-[1240px] flex-wrap items-center gap-6 px-[18px] pb-9 pt-[30px] sm:px-10">
				<div className="h-[18px] text-white">
					<Wordmark />
				</div>
				<nav aria-label="Legal" className="ml-auto flex gap-[22px] text-[13px]">
					<Link to={SITE_LINKS.terms} className={LEGAL_LINK}>
						{copy.terms}
					</Link>
					<Link to={SITE_LINKS.privacy} className={LEGAL_LINK}>
						{copy.privacy}
					</Link>
					<button
						type="button"
						onClick={openPreferences}
						aria-haspopup="dialog"
						className={LEGAL_LINK}
					>
						{copy.privacyChoices}
					</button>
				</nav>
				<p className="w-full text-[12.5px] text-white/60">
					&copy; <CurrentYear /> {copy.company}
				</p>
			</div>
		</footer>
	)
}

/**
 * The year is read from the clock, so the server (UTC) and a visitor whose
 * local year differs (New Year's Eve evening in Toronto) disagree. The
 * mismatch is expected and harmless here: React keeps the server's year for
 * that one text node instead of throwing away the whole tree.
 */
function CurrentYear() {
	return <span suppressHydrationWarning>{new Date().getFullYear()}</span>
}
